import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as OptionLabelsActions from './option-labels.actions';
import { SearchFilterLabelsEntity } from './search-filter-labels.models';

export const OPTION_LABELS_FEATURE_KEY = 'optionLabels';

export interface OptionLabelsState extends EntityState<SearchFilterLabelsEntity> {
  loaded: boolean; // has the SearchFilterLabels list been loaded
  error?: string | null; // last known error (if any)
}

export interface OptionLabelsPartialState {
  readonly [OPTION_LABELS_FEATURE_KEY]: OptionLabelsState;
}

export const optionLabelsAdapter: EntityAdapter<SearchFilterLabelsEntity> =
  createEntityAdapter<SearchFilterLabelsEntity>({ selectId: (labelsEntity) => labelsEntity?.key });

export const initialOptionLabelsState: OptionLabelsState = optionLabelsAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const reducer = createReducer(
  initialOptionLabelsState,
  on(OptionLabelsActions.loadOptionLabels, (state) => optionLabelsAdapter.removeAll({ ...state })),
  on(OptionLabelsActions.loadOptionLabelsSuccess, (state, { optionLabels }) =>
    optionLabelsAdapter.addMany(optionLabels, { ...state, loaded: true })
  ),
  on(OptionLabelsActions.loadOptionLabelsFailure, (state, { error }) => ({ ...state, error })),
  on(OptionLabelsActions.removeExhibitorFilterLabel, (state) => optionLabelsAdapter.removeOne('exhibitor', state))
);

export function optionLabelsReducer(state: OptionLabelsState | undefined, action: Action) {
  return reducer(state, action);
}
